import { Project, DataFilter } from "interfaces";

import { FLOW_NAME as BINARY_FLOW_NAME } from "flows/driver-analysis-binary/config";
import { FLOW_NAME as CONTINOUS_FLOW_NAME } from "flows/driver-analysis-continous/config";
import * as flowConfig from "./config";

export type OutcomeType = "binary" | "continous";

export interface BinaryOutcome {
  type: "binary";
  definition: DataFilter.Filter[];
  variable: string;
  tag_ones: string;
  tag_zeros: string;
}

export interface ContinousOutcome {
  type: "continous";
  variable: string;
}

export type Outcome = BinaryOutcome | ContinousOutcome;

export const outcomeIsBinary = (outcome: Outcome): outcome is BinaryOutcome =>
  outcome?.type === "binary";

export const outcomeIsContinous = (
  outcome: Outcome
): outcome is ContinousOutcome =>
  outcome?.type === "continous" || typeof outcome === "string";

export interface DriverAnalysisProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.INPUT_DATA]: string;
    [flowConfig.AUGMENTED_FILE]?: string;
  };
  meta_data: {
    outcomes: Outcome[];
  };
  workspaces: {
    key: string;
    workspace: string;
    meta_data: {
      key: string;
      "outcome-variable": string;
      "variable-mapping": {
        [flowConfig.TIME_VARIABLE]?: string;
        [flowConfig.GROUPING_VARIABLES]?: string[];
        [flowConfig.LABEL_VARIABLES]?: string[];
        [flowConfig.ENTITY_VARIABLES]?: string[];
      };
    };
  }[];
}

export type ModelAnnotationsInterface = {
  url: string;
  [flowConfig.RUN_ID]: string;
  [flowConfig.INIT_RUN]: boolean;
  [flowConfig.CREATED_BY]: string;
  [flowConfig.TIME_STAMP]: number;
};

export const projectIsDriverAnalysis = (
  project: Project
): project is DriverAnalysisProject =>
  project.flow === flowConfig.FLOW_NAME ||
  project.flow === CONTINOUS_FLOW_NAME ||
  project.flow === BINARY_FLOW_NAME;
